import { apiService } from './api';
import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  email: string;
  exp: number;
}

class AuthService {
  private tokenKey = 'authToken';
  private emailKey = 'userEmail';

  async sendMagicLink(email: string, redirect?: string | null): Promise<void> {
    await apiService.sendMagicLink(email, redirect);
  }

  async verifyMagicLink(token: string): Promise<{ email: string; redirect?: string | null }> {
    const response = await apiService.verifyMagicLink(token);
    this.setToken(response.token);
    this.setEmail(response.email);
    return { email: response.email, redirect: response.redirect };
  }

  async verifyShortLink(code: string): Promise<{ email: string; groupId: string }> {
    const response = await apiService.verifyShortLink(code);
    this.setToken(response.token);
    this.setEmail(response.email);
    return { email: response.email, groupId: response.groupId };
  }

  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  setEmail(email: string): void {
    localStorage.setItem(this.emailKey, email);
  }

  getEmail(): string | null {
    return localStorage.getItem(this.emailKey);
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;
    try {
      const decoded: DecodedToken = jwtDecode(token);
      return decoded.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.emailKey);
  }
}

export const authService = new AuthService();
export default authService;
